import styled from "styled-components";

export const AlertStyled = styled.div`
  background-color: ${({ theme }) => theme.old.colors.gray[175]};
  border-radius: 4px;
  font-size: ${({ theme }) => theme.old.fonts.size.smaller};
  font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
  line-height: 20px;
  padding: 8px;
  width: max-content;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 150%;

  display: flex;
  align-items: center;
  gap: 4px;

  ::before {
    content: '';
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%) rotate(135deg);

    border-top-right-radius: 2px;
    background: linear-gradient(
      45deg,
      rgba(0,0,0,0) 45%,
      ${({ theme }) => theme.old.colors.gray[175]} 46%
    );
    width: 12px;
    height: 12px;
  }
  
  @media screen and (max-width: 1150px) {
    right: 0;
    left: unset;
    transform: translate(0);

    ::before{
      left: 80.5%;
    }
  }
`